export type ServiceLevelTone = 'success' | 'warning' | 'error';

export function getServiceLevelTone(percentage: number): ServiceLevelTone {
  if (percentage >= 80) return 'success';
  if (percentage >= 60) return 'warning';
  return 'error';
}

export const SERVICE_LEVEL_TEXT_COLORS: Record<ServiceLevelTone, string> = {
  success: '#059669',
  warning: '#D97706',
  error: '#DC2626',
};

export const SERVICE_LEVEL_BAR_COLORS: Record<ServiceLevelTone, string> = {
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
};
